import { useMemo } from 'react';
import type { IUseQualifyingDialogParams } from '../interfaces';

/**
 * Qualifying-step dialog state: current answer lookup, next-button
 * gating, and back/cancel navigation. The view only wires the result
 * into JobPostDialog props.
 */
export const useQualifyingDialog = ({
  loading,
  qualifyingAnswers,
  qualifyingQuestions,
  currentQualifyingStep,
  setCurrentQualifyingStep,
  setIsQualifyingModalOpen,
  setIsQualifyingCancelDialogOpen,
}: IUseQualifyingDialogParams) => {
  const currentQualifyingAnswer = useMemo(
    () =>
      qualifyingAnswers.find(
        (answer) => answer.questionId === qualifyingQuestions[currentQualifyingStep]?.questionId,
      ),
    [qualifyingAnswers, qualifyingQuestions, currentQualifyingStep],
  );

  const isQualifyingNextDisabled =
    loading || !currentQualifyingAnswer || currentQualifyingAnswer.answer === '';

  const handleQualifyingDialogClose = (): void => {
    if (currentQualifyingStep === 0) {
      setIsQualifyingCancelDialogOpen(true);
    } else {
      setCurrentQualifyingStep((prev) => prev - 1);
    }
  };

  const handleCancelQualifying = (): void => {
    setIsQualifyingCancelDialogOpen(false);
    setIsQualifyingModalOpen(false);
  };

  return {
    currentQualifyingAnswer,
    isQualifyingNextDisabled,
    handleQualifyingDialogClose,
    handleCancelQualifying,
  };
};
